import { mapPayments } from "./paymentMapper";

export const mapExportInvoiceSale = (formData: any) => {
  return {
    saleId: formData.id ?? null,
    branch: formData.branch ?? null,
    customer: formData.customer ?? null,
    documentType: formData.documentType ?? null,
    saleDate: formData.saleDate,

    // 💰 Condiciones de pago
    paymentCondition: formData.paymentCondition ?? null,
    // paymentMethod: formData.paymentMethod ?? null,
    // individualPayments: formData.individualPayments || {},
    payments: mapPayments(formData.payments),

    comments: formData.comments || null,

    // 🌍 Datos propios de exportación
    // exportItemType: formData.exportItemType ?? null,
    // fiscalPrecinct: formData.fiscalPrecinct ?? null,
    // exportRegime: formData.exportRegime ?? null,
    // incoterm: formData.incoterm ?? null,

    // // 🚢 Extras
    // freight: formData.freight ?? 0,
    // insurance: formData.insurance ?? 0,
  };
};
